// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=date][data-v-1cb3884b] {\n  min-width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
